<script setup lang="ts">
import { DialogContent, DialogPortal, DialogRoot, DialogTrigger } from "reka-ui";

const isOpened = ref(false);
watch(isOpened, (newValue) => {
  if (newValue) document.documentElement.classList.add("menu-mobile-opened");
  else document.documentElement.classList.remove("menu-mobile-opened");
});
</script>

<template>
  <DialogRoot v-model:open="isOpened">
    <DialogTrigger>
      <UiHamburger :is-opened="isOpened" />
    </DialogTrigger>
    <DialogPortal>
      <UiDialogOverlay />
      <DialogContent class="animation-menu-mobile dark color-dark fixed inset-y-0 left-0 w-menuMobile overflow-y-scroll px-6 transition">
        <SiteMenuMobile />
      </DialogContent>
    </DialogPortal>
  </DialogRoot>
</template>

<style lang="postcss">
#app { @apply transition-transform; }
html.menu-mobile-opened {
  &, body { @apply w-full overflow-x-hidden; }
  body { @apply max-h-screen;}
  #app { @apply translate-x-menuMobile; }
}
</style>
